module.exports = __webpack_public_path__ + "static/media/eComicScreenPlus-03_2x.cb37f22a.png";